export const formatBusinessId = (businessId: number | string): string => {
    return businessId.toString().padStart(8, '0');
};
